const about = {
  about: {
    hero: {
      badge: 'من نحن',
      title: 'نُعيد تعريف العقارات في المملكة العربية السعودية',
      subtitle: 'صفقات 24 هي منصة عقارية من الجيل التالي صُمِّمت لتحقيق الشفافية والذكاء والثقة في سوق العقارات السعودي.',
    },
    mission: {
      title: 'رسالتنا',
      description: 'تمكين كل فرد ووسيط وشركة في سوق العقارات السعودي بالأدوات والبيانات والعلاقات التي يحتاجونها لاتخاذ قرارات عقارية واثقة - مدعومة بالتكنولوجيا، موجّهة بالثقة.',
    },
    vision: {
      title: 'رؤيتنا',
      description: 'أن نصبح المنصة العقارية الأكثر موثوقية وذكاءً في المملكة العربية السعودية، ونضع معايير جديدة لكيفية اكتشاف العقارات وتقييمها والتعامل بها.',
    },
    story: {
      title: 'قصتنا',
      paragraphs: [
        'تأسست صفقات 24 في جدة بهدف واضح: سوق العقارات السعودي يستحق الأفضل. أدوات أفضل للوسطاء. شفافية أكبر للمشترين. بيانات أدق للجميع.',
        'لاحظنا أن الباحثين عن عقارات يواجهون غالباً إعلانات قديمة ومعلومات غير موثوقة وتواصل مشتت. كان الوسطاء يفتقرون إلى أدوات حديثة لإدارة عملياتهم بكفاءة. وكان السوق ككل يفتقر إلى الشفافية التي تبني الثقة.',
        'لذلك بنينا صفقات 24 - منصة شاملة تجمع بين التكنولوجيا المتقدمة والفهم العميق للمشهد العقاري السعودي. من البحث المدعوم بالذكاء الاصطناعي إلى شبكات الوسطاء الموثّقين، ومن ذكاء السوق إلى المعاملات السلسة، كل ميزة صُمِّمت مع وضع مستخدمينا في الاعتبار.',
        'اليوم، نخدم الباحثين عن عقارات والوسطاء المرخّصين والوكلاء والشركات العقارية في جميع أنحاء المملكة، ونساعدهم على التنقل في السوق بثقة ووضوح.',
      ],
    },
    values: {
      title: 'قيمنا',
      items: [
        {
          icon: 'ri-shield-check-line',
          title: 'الثقة والشفافية',
          description: 'كل وسيط موثّق من الهيئة العامة للعقار. كل إعلان يخضع لمعايير عالية. نؤمن بأن الثقة هي أساس كل صفقة ناجحة.',
        },
        {
          icon: 'ri-lightbulb-flash-line',
          title: 'الابتكار',
          description: 'من البحث العقاري المدعوم بالذكاء الاصطناعي إلى المطابقة الذكية للعملاء المحتملين، نستفيد من أحدث التقنيات لحل مشكلات حقيقية في صناعة العقارات.',
        },
        {
          icon: 'ri-user-heart-line',
          title: 'المستخدم أولاً',
          description: 'سواء كنت مستأجراً لأول مرة أو وسيطاً محترفاً، المنصة مصممة حول احتياجاتك. كل ميزة موجودة لأن مستخدمينا يحتاجونها.',
        },
        {
          icon: 'ri-bar-chart-grouped-line',
          title: 'قرارات مبنية على البيانات',
          description: 'نوفر ذكاء السوق وتحليلات الأحياء ورؤى العقارات حتى يكون كل قرار مبنياً على بيانات موثوقة ومحدّثة.',
        },
        {
          icon: 'ri-scales-3-line',
          title: 'الامتثال والنزاهة',
          description: 'نعمل في امتثال كامل لأنظمة الهيئة العامة للعقار وقوانين حماية البيانات السعودية وأفضل ممارسات الصناعة. النزاهة غير قابلة للتفاوض.',
        },
        {
          icon: 'ri-hand-heart-line',
          title: 'الأثر المجتمعي',
          description: 'نلتزم بدعم رؤية 2030 من خلال جعل تملك العقارات والاستثمار فيها أكثر سهولة لجميع سكان المملكة.',
        },
      ],
    },
    platform: {
      title: 'ما نقدمه',
      subtitle: 'منظومة متكاملة لسوق العقارات السعودي',
      features: [
        {
          icon: 'ri-search-eye-line',
          title: 'بحث عقاري ذكي',
          description: 'بحث مدعوم بالذكاء الاصطناعي يفهم ما تبحث عنه، مع فلاتر متقدمة واستكشاف بالخرائط واستعلامات باللغة الطبيعية بالعربية والإنجليزية.',
        },
        {
          icon: 'ri-verified-badge-line',
          title: 'شبكة وسطاء موثّقين',
          description: 'جميع الوسطاء موثّقون عبر الهيئة العامة للعقار ونظام رخص فال. تعامل مع مختصين تثق بهم.',
        },
        {
          icon: 'ri-line-chart-line',
          title: 'ذكاء السوق',
          description: 'تقييمات الأحياء ومعدلات المشي وجودة المدارس ومؤشرات الأمان ومقاييس سرعة السوق الفورية لتوجيه قراراتك.',
        },
        {
          icon: 'ri-exchange-funds-line',
          title: 'سوق العملاء المحتملين',
          description: 'سوق ديناميكي يربط الباحثين عن عقارات بالوسطاء المناسبين - مع خيارات عملاء مجانية ومدفوعة وحصرية ومطابقة بالذكاء الاصطناعي.',
        },
        {
          icon: 'ri-robot-2-line',
          title: 'المساعد الذكي',
          description: 'مساعد دردشة ثنائي اللغة يساعدك في العثور على عقارات وجدولة المعاينات والحصول على إجابات فورية لاستفساراتك العقارية.',
        },
        {
          icon: 'ri-panorama-2-line',
          title: 'جولات افتراضية',
          description: 'جولات عقارية بتقنية البانوراما 360 درجة تتيح لك استكشاف المنازل من أي مكان وفي أي وقت.',
        },
        {
          icon: 'ri-money-dollar-circle-line',
          title: 'إدارة العمولات',
          description: 'تتبع شفاف للعمولات وحسابات آلية ومعالجة مدفوعات سلسة لكل معاملة.',
        },
        {
          icon: 'ri-customer-service-2-line',
          title: 'استشارات متخصصة',
          description: 'احجز جلسات استشارية فردية مع خبراء عقاريين للحصول على إرشادات مخصصة حول الشراء أو البيع أو الاستثمار.',
        },
      ],
    },
    compliance: {
      title: 'منظّمون وملتزمون',
      description: 'نعمل تحت إشراف الهيئة العامة للعقار وفي امتثال كامل لأنظمة ولوائح المملكة العربية السعودية.',
      items: [
        'مرخّصون من الهيئة العامة للعقار مع تفويض فال ساري',
        'ملتزمون بنظام حماية البيانات الشخصية',
        'متوافقون مع أنظمة التجارة الإلكترونية',
        'مسجّلون في ضريبة القيمة المضافة لدى زاتكا بنسبة 15%',
        'معالجة مدفوعات آمنة عبر مُيسّر',
      ],
    },
    stats: {
      title: 'صفقات 24 في لمحة',
      items: [
        { value: 'جدة', label: 'المقر الرئيسي' },
        { value: '24/7', label: 'متاحة على مدار الساعة' },
        { value: 'ع/EN', label: 'دعم ثنائي اللغة' },
        { value: 'الهيئة', label: 'مرخّصة ومنظّمة' },
      ],
    },
    cta: {
      title: 'مستعد للبدء؟',
      description: 'سواء كنت تبحث عن منزل أحلامك، أو تُدرج عقاراً، أو تنمّي أعمال الوساطة - صفقات 24 هنا من أجلك.',
      primaryButton: 'استكشف العقارات',
      secondaryButton: 'تواصل معنا',
    },
    // حقوق الصور (/about#photo-credits). القائمة نفسها في src/config/photoCredits.ts.
    credits: {
      title: 'حقوق الصور',
      intro: 'نشكر المصوّرين الذين أتاحوا صورهم بتراخيص مفتوحة.',
      editedNote: 'الصور المعدّلة قُصّت أو غُيّر حجمها أو ألوانها لتناسب الموقع.',
      by: 'تصوير',
      licence: 'الترخيص',
      source: 'المصدر',
      edited: 'معدّلة',
      newTab: '(يفتح في نافذة جديدة)',
      sites: { commons: 'ويكيميديا كومنز' },
      usedOn: {
        cityCard: 'بطاقة المدينة في الصفحة الرئيسية',
        hero: 'خلفية أعلى الصفحة الرئيسية',
      },
      subjects: {
        makkah: 'المسجد الحرام، مكة المكرمة',
        madinah: 'المسجد النبوي، المدينة المنورة',
        riyadh: 'أفق شمال الرياض',
        jeddah: 'كورنيش جدة',
        dammam: 'كورنيش الدمام',
        hero: 'أفق الرياض',
      },
    },
  },
};

export default about;
